import { render, staticRenderFns } from "./404.vue?vue&type=template&id=cb6dfc12"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb6dfc12')) {
      api.createRecord('cb6dfc12', component.options)
    } else {
      api.reload('cb6dfc12', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=cb6dfc12", function () {
      api.rerender('cb6dfc12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/error-page/404.vue"
export default component.exports